import { Complemento } from './usuario-retorno-dto';

export class Usuario {
    menu: any;
    perfil: any;
    nome: string;
    esfera?: any;
    cpf?: string;
    login: string;
    perfis: Array<any>;
    esferas?: Array<any>;
    permissoes: Array<any>;
    complemento: Complemento;
    foto = 'assets/imgs/img-foto-user3.png';
    token?: {
        jti: string,
        scope: string,
        token_type: string,
        accessToken: string,
        organization: string,
        refresh_token: string,
        expDate?: Date
    };
}
